import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const classes = {
  root: {
    padding: 4,
    position: 'relative',
  },
};

export default function NotFound() {
  const location = useLocation();

  return (
    <Box sx={classes.root}>
      <Typography component="h3" variant="h6">
        Not Found
      </Typography>
      <Typography>
        There's nothing to display for <b>{location.pathname}</b>.{' '}
        <Link to="/">Click here</Link> to return home.
      </Typography>
    </Box>
  );
}
